import React, { Component } from 'react';

import { withTranslation } from 'react-i18next';

import './footerComponent.css';

class FooterComponent extends Component {
    render() {
        return (
            <div className="footer-container">
                <a href="https://www.digit.fi/viralliset/tietosuojaseloste/" rel="noopener noreferrer" target="_blank">
                    {this.props.t('footer.privacy')}
                </a>
                <a href="https://www.digit.fi/" rel="noopener noreferrer" target="_blank">
                    {this.props.t('footer.website')}
                </a>
                <a href="mailto:digit@utu.fi" rel="noopener noreferrer" target="_blank">
                    {this.props.t('footer.contact')}
                </a>
            </div>
        );
    }
}

export default withTranslation()(FooterComponent);
